import { ref } from "vue";

export function usePendingChanges() {
  const warningMultipleVisible = ref(false);
  const multipleFieldOne = ref<any>({});
  const multipleFieldTwo = ref<any>({});

  return { warningMultipleVisible, multipleFieldOne, multipleFieldTwo };
}
